import request, { downloadRequest, getAPIToken, checkStatus } from "utils/request";

import { toast } from "react-toastify";

import { baseRequestURL as baseURL } from "api/BaseAPI";

const baseRequestURL = baseURL + "v1/score/";

export function getScoreStatus(scoreId) {
  return request(baseRequestURL + scoreId, {
    method: "GET",
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function getScoreFile(scoreId) {
  return downloadRequest(baseRequestURL + scoreId + "/download", {
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function getScore(account, scoreId) {
  const apiToken = getAPIToken();
  const agentEndpoint = account?.configuration?.cloud_base_url;

  return request(agentEndpoint + "/v1/deploy/" + scoreId, {
    method: "GET",
    headers: { Authorization: "Bearer " + apiToken }
  }).then((response) => response);
}

export function getScores() {
  return request(baseURL + "v1/scores", {
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function uploadPrediction(jobId, modelId, file, accountId) {
  const data = new FormData();

  data.append("file", file);
  data.append("name", file.name);
  data.append("model_name", modelId);
  data.append("account_id", accountId);

  return request(baseURL + "v1/job/" + jobId + "/scores", {
    method: "POST",
    body: data,
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function getBulkScoreEndpoint(accountId) {
  return request(baseURL + "v1/account/" + accountId + "?i=configuration", {
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function postExecutor(accountId) {
  return request(baseURL + "v1/account/" + accountId + "/executor", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function createDatasetFromMonitor(projectId) {
  return request(baseURL + "v1/projects/" + projectId + "/monitor_snapshots", {
    method: "POST",
    headers: {
      Authorization: "Bearer " + getAPIToken()
    }
  }).then((response) => response);
}

export function fetchForecast(projectId, endpoint, endpointHeaders = {}, time, unit) {
  return request(endpoint, {
    method: "GET",
    headers: {
      "Content-Type": "text/csv",
      ...endpointHeaders
    }
  });
}

function shouldRetryFetch(response, retries) {
  const retRetries = retries && isFinite(retries) ? retries : 0;
  return response.status === 202 || (retRetries < 3 && (response.status === 502 || response.status === 504));
}

function predictionResponseHandler(response, retries = 0) {
  if (shouldRetryFetch(response, retries)) {
    return response;
  } else {
    let errorMessage = undefined;

    switch (response.status) {
      case 504:
        errorMessage = "There was an error processing your request. Please reduce the number of rows and try again.";
        break;
      case 400:
        errorMessage = "There was an error reading your file. Please correct any errors and try again.";
        break;
      case 500:
      case 502:
        errorMessage = "There was an error processing your request.";
        break;
    }

    if (errorMessage !== undefined) {
      toast(errorMessage, {
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
        autoClose: 7500
      });
      throw response;
    }
    return checkStatus(response);
  }
}
